import { render, staticRenderFns } from "./sidebarMainWallet.vue?vue&type=template&id=21a1bf74&"
import script from "./sidebarMainWallet.vue?vue&type=script&lang=js&"
export * from "./sidebarMainWallet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports